/**
 * CSRF トークン管理
 * api.ts で使用
 */

// CSRF設定
const CSRF_HEADER_NAME = 'X-CSRF-Token';
const CSRF_STORAGE_KEY = 'csrf_token';

// CSRFトークンキャッシュ
let csrfTokenCache: string | null = null;

/**
 * CSRFトークンを取得（メモリまたはsessionStorageから）
 */
export function getCsrfToken(): string | null {
  if (csrfTokenCache) {
    return csrfTokenCache;
  }
  // sessionStorageからフォールバック取得
  const storedToken = sessionStorage.getItem(CSRF_STORAGE_KEY);
  if (storedToken) {
    csrfTokenCache = storedToken;
  }
  return csrfTokenCache;
}

/**
 * CSRFトークンを保存
 */
export function setCsrfToken(token: string): void {
  csrfTokenCache = token;
  // sessionStorageにも保存（ページリロード対策）
  sessionStorage.setItem(CSRF_STORAGE_KEY, token);
}

/**
 * CSRFトークンをクリア
 */
export function clearCsrfToken(): void {
  csrfTokenCache = null;
  sessionStorage.removeItem(CSRF_STORAGE_KEY);
}

/**
 * CSRFトークン付きのヘッダーを作成
 */
export function createHeaders(includeJson: boolean = true): HeadersInit {
  const headers: HeadersInit = {};

  if (includeJson) {
    headers['Content-Type'] = 'application/json';
  }

  const csrfToken = getCsrfToken();
  if (csrfToken) {
    headers[CSRF_HEADER_NAME] = csrfToken;
  }

  return headers;
}

